import type { AdminRole } from '@/lib/api-admin';

/**
 * 매출 수집 Open API 제휴사 관리 권한(order-service AdminOpenApiPartnerController @PreAuthorize 와 같음).
 * 조회(목록·상세·이력) = SUPER_ADMIN·OPS_ADMIN, 등록·수정·키 재발급·삭제 = SUPER_ADMIN 만.
 */
export const OPEN_API_PARTNER_READ_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN', 'OPS_ADMIN'];
export const OPEN_API_PARTNER_WRITE_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN'];
